import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { programsApi } from "../services/api";
import { RichContent } from "../components/RichContent";

function ProgramDetailPage() {
  const { slug } = useParams();
  const [program, setProgram] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchProgram();
  }, [slug]);

  const fetchProgram = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await programsApi.getBySlug(slug);
      setProgram(response.data);
    } catch (err) {
      console.error("Error loading program:", err);
      setError("Program not found");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-96">
        <div className="text-gray-500">Loading...</div>
      </div>
    );
  }

  if (error || !program) {
    return (
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-red-50 border border-red-200 rounded-lg p-8 text-center">
          <h1 className="text-2xl font-bold text-red-800 mb-4">
            Program Not Found
          </h1>
          <p className="text-red-600 mb-6">
            {error || "The program you are looking for does not exist."}
          </p>
          <Link
            to="/programs"
            className="inline-block bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition"
          >
            Back to Programs
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div>
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-[#1F3A5F] to-[#3B82F6] text-white py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-6">
            <Link
              to="/programs"
              className="text-blue-100 hover:text-white transition"
            >
              ← Back to Programs
            </Link>
          </div>
          <div className="flex items-start gap-6 mb-6">
            {program.icon && <div className="text-6xl">{program.icon}</div>}
            <div>
              <h1 className="text-4xl md:text-5xl font-bold mb-4">
                {program.title}
              </h1>
              <p className="text-blue-100 text-xl">{program.description}</p>
            </div>
          </div>
          <div className="flex gap-6 mt-8">
            {program.duration && (
              <div className="bg-blue-500 bg-opacity-20 px-4 py-2 rounded-lg">
                <div className="text-sm text-blue-100">Duration</div>
                <div className="font-semibold">{program.duration}</div>
              </div>
            )}
            {Boolean(program.show_price) && (
              <div className="bg-blue-500 bg-opacity-20 px-4 py-2 rounded-lg">
                <div className="text-sm text-blue-100">Price</div>
                <div className="font-semibold">{program.price != 0 ? `BDT ${program.price}` : "Contact for pricing"}</div>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {program.detailed_content ? (
            <div className="prose prose-lg max-w-none">
              {/* <div
                dangerouslySetInnerHTML={{ __html: program.detailed_content }}
              /> */}
              <RichContent html={program.detailed_content} />
            </div>
          ) : (
            <div className="bg-gray-50 rounded-lg p-8">
              <p className="text-gray-600 text-center">{program.description}</p>
            </div>
          )}
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-blue-600 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold mb-4">Ready to Enroll?</h2>
          <p className="mb-8 text-blue-100 text-lg">
            Start your learning journey with {program.title} today.
          </p>
          <Link
            to="/contact"
            className="inline-block bg-white text-blue-600 px-8 py-3 rounded-full font-semibold hover:bg-gray-100 transition"
          >
            Get Started
          </Link>
        </div>
      </section>

      {/* Back to Programs */}
      <section className="py-12 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <Link
            to="/programs"
            className="text-blue-600 font-semibold hover:text-blue-700 transition"
          >
            ← View All Programs
          </Link>
        </div>
      </section>
    </div>
  );
}

export default ProgramDetailPage;
